import React, { useEffect, Suspense, lazy } from 'react';
import { CssBaseline, ThemeProvider, CircularProgress, Box } from '@mui/material';
import { Routes, Route, Navigate } from 'react-router-dom';
import { notebookLMTheme } from './theme';
import CollectionService from './services/CollectionService';
import ErrorBoundary from './components/ErrorBoundary';

// Lazy load pages for code splitting
const Dashboard = lazy(() => import('./pages/Dashboard'));
const OpenWebUIPage = lazy(() => import('./pages/OpenWebUIPage'));

const App: React.FC = () => {
  useEffect(() => {
    // Collection initialisieren
    const collectionService = CollectionService.getInstance();
    const id = collectionService.getCollectionId();
    
    console.log('App initialisiert mit Collection:', id);
  }, []);

  // Loading fallback component
  const LoadingFallback = () => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#f5f5f5'
      }}
    >
      <CircularProgress />
    </Box>
  );

  return (
    <ErrorBoundary
      onError={(error, errorInfo) => {
        // Optional: Log to error reporting service
        console.error('Application error:', error, errorInfo);
      }}
    >
      <ThemeProvider theme={notebookLMTheme}>
        <CssBaseline />
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route 
              path="dashboard" 
              element={
                <ErrorBoundary>
                  <Dashboard />
                </ErrorBoundary>
              } 
            />
            <Route 
              path="openwebui" 
              element={
                <ErrorBoundary>
                  <OpenWebUIPage />
                </ErrorBoundary>
              } 
            />
          </Routes>
        </Suspense>
      </ThemeProvider>
    </ErrorBoundary>
  );
};

export default App;
